import { Address } from '~api/address_book';

import { useTranslation } from 'react-i18next';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { AddressMultiline } from '~src/components/AddressMultiline/AddressMultiline';
import { LocalizationKey } from '~src/i18n/use-translation';

interface Props {
  label: LocalizationKey;
  address?: Address;
  email?: string;
  phone?: string;
}

export function AddressCard({ label, address, email, phone }: Props) {
  const { t } = useTranslation();

  return (
    <Card.Wrapper style={{ height: '200px' }}>
      <Card.Content>
        <ListLayout.Column style={{ height: '100%', display: 'flex', justifyContent: 'space-between', gap: 0 }}>
          <ListLayout.Row>
            <Card.Header>{t(label)}</Card.Header>
          </ListLayout.Row>
          <ListLayout.Stack style={{ gap: 0 }}>
            <AddressMultiline address={address} email={email} phone={phone} />
          </ListLayout.Stack>
        </ListLayout.Column>
      </Card.Content>
    </Card.Wrapper>
  );
}
